import { library } from '@fortawesome/fontawesome-svg-core';
import {
  faAlignJustify,
  faUser,
  faDesktop,
  faPlay,
  faReceipt,
  faUserCircle,
  faIdBadge,
  faRedo,
  faTimesCircle,
  faCheck,
  faStar,
  faExclamationTriangle,
  faCreditCard,
  faExchangeAlt,
  faFlag,
  faAngleDown,
  faCalendarAlt,
} from '@fortawesome/free-solid-svg-icons';

library.add(
  faAlignJustify,
  faUser,
  faDesktop,
  faPlay,
  faReceipt,
  faUserCircle,
  faIdBadge,
  faRedo,
  faTimesCircle,
  faCheck,
  faStar,
  faExclamationTriangle,
  faCreditCard,
  faExchangeAlt,
  faFlag,
  faAngleDown,
  faCalendarAlt,
);
